import { PropTypes } from 'prop-types'

import { Table, Skeleton } from '@chakra-ui/react'

export const PointTable = ({ pointList }) => {
  const body = (pointList) => {
    if (pointList) {
      return pointList.map((row, index) => {
        return (
          <Table.Row key={index}>
            <Table.Cell textAlign={'center'}>{row.expire_date}</Table.Cell>
            <Table.Cell textAlign={'center'}>{row.point_count}pt</Table.Cell>
          </Table.Row>
        )
      })
    }

    return Array(4)
      .fill()
      .map((_i, index) => {
        return (
          <Table.Row key={index}>
            <Table.Cell colSpan={2}>
              <Skeleton height="1rem" />
            </Table.Cell>
          </Table.Row>
        )
      })
  }

  return (
    <Table.ScrollArea>
      <Table.Root variant="simple">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader textAlign={'center'}>有効期限</Table.ColumnHeader>
            <Table.ColumnHeader textAlign={'center'}>pt数</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>{body(pointList)}</Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  )
}

PointTable.propTypes = {
  pointList: PropTypes.arrayOf(
    PropTypes.shape({
      expire_date: PropTypes.string.isRequired,
      point_count: PropTypes.number.isRequired,
    }),
  ),
}
